<template>
   <div id="app" ref="app" :class="{ 'mobile': $teras.device()==='mobile' }">

      <div ref="refdue" class="refdue" :style="{ width: larghezza + 'px', display:'none' }"></div>

      <div v-if="$teras.device()!='mobile'" id="side" class="fixed-side" :style="'margin-left:'+(larghezza-200)+'px'"><site-side></site-side></div>
      <header-mobile v-if="$teras.device()=='mobile'"></header-mobile>

      <router-view v-if="$teras.device()!='mobile'" name="main" :style="'padding:0 0 0 20px;width:'+(larghezza-200)+'px'"></router-view>
      <router-view v-if="$teras.device()=='mobile'" name="main" :style="'padding:0 10px 0 10px;'"></router-view>
  
   </div> <!-- end app -->
</template>

<script>
import headerMobile from './components/Header-mobile.vue'
//import siteHeader from './components/Site-header.vue'
import siteSide from './components/Site-side.vue'
//import imageInside from './components/Image-inside.vue'
//import siteNavbar from './components/Site-navbar.vue'
//import siteFooter from './components/Site-footer.vue'

export default {
   name: 'app',
   components: {
      headerMobile,
      //siteHeader,
      siteSide,
      //imageInside,
      //siteNavbar,
      //siteFooter
   },
  data(){
    return {
      larghezza:0
    }
  },
  created () {
    console.log("Created App.vue") 
    console.log(this.$route.path)   
    //
  },
  mounted: function () {
    this.larghezza = parseInt(this.$refs.app.clientWidth);
    window.addEventListener('resize', this.handleResize)
    //window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
    //window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleResize(){
      //console.log(this.$refs.rmain.clientWidth)
      this.$teras.innerHeight =  window.innerHeight
      this.$teras.innerWidth = window.innerWidth

      /*
      console.log(this.$route.meta.device + " && " + this.$teras.device())
      if(this.$route.meta.device == 'mobile' && this.$teras.device()!='mobile'){
        console.log(this.$route.path.replace("-mobile", ""))
        this.$router.replace(this.$route.path.replace("-mobile", ""))
      }
      if(this.$route.meta.device != 'mobile' && this.$teras.device()=='mobile'){
        if(this.$route.path.toLowerCase().indexOf("-mobile") == -1)
        //this.$router.replace(this.$route.path.replace("-mobile", ""))
          this.$router.replace(this.$route.path+"-mobile")
      }
      */

      this.larghezza = parseInt(this.$refs.app.clientWidth);
      console.log(this.$teras.width+ ' - ' +this.$teras.innerWidth)
      console.log(window.innerWidth)
      // console.log(document.documentElement.clientWidth)
    }
  }
}
</script>

<style>
body{
  
}#app{
  max-width: 1220px;
  width: 100%;
  margin:60px auto 0 auto;
}#app.mobile{
  margin:80px auto 0 auto;
}.fixed-side{
  background: #ffffff;
  height: 100%;
  position: fixed;
  width:200px;
  padding:0 20px 20px 20px;
}#main{

}.refdue{
  background:red;
  height: 200px;
  width:500px;
  display: block;
  position: absolute;
  left: 0;
  bottom:0;
  font-size:3.4rem;
  color:#ffffff;
}

</style>



// WEBPACK FOOTER //
// App.vue?75d92f68